import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { StorageService } from '@coin/shared/core/data-access';
import { ContentLanguage, StorageKey } from '@coin/shared/core/util-enums';
import { TranslateService } from '@ngx-translate/core';
import { UpdateNotificationsService } from '@coin/shared/core/util-helpers';

@Component({
  selector: 'importer-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  private translate = inject(TranslateService);
  private storageService = inject(StorageService);

  constructor() {
    inject(UpdateNotificationsService).checkForUpdates();
    this.initializeApp();

    const lang = this.storageService.get(StorageKey.LANGUAGE);
    this.translate.use(lang ?? ContentLanguage.ENGLISH);
  }

  initializeApp(): void {
    this.translate.setDefaultLang(ContentLanguage.ENGLISH);
  }
}
